import { TeamUserPage } from '@/features/team/pages/TeamUserPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/users/$userId')({
  component: TeamUserPage,
});
